import VueSocketIO from "vue-socket.io-extended";
import io from "socket.io-client";
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import config from "./config";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

let url = ''
if (Vue.$cookies.isKey('socket')) {
    url = config[Vue.$cookies.get('socket')]
} else {
    Vue.$cookies.set('socket', 'production')
    url = config[Vue.$cookies.get('socket')]
}

// Vue.use(VueSocketIO, io("http://localhost:7070"));
//let url = 'http://127.0.0.1:7070';


let token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InJvbElkIjo5LCJ1c2VybmFtZSI6Imlub3ZlbGEiLCJ1c3VhcmlvSWQiOjMxLCJpZFVzdWFyaW8iOjMwLCJjbGllbnRlU29ja2V0Ijp0cnVlLCJ3aGl0ZUxpc3QiOlsiNDQ2MiIsIjQ0NjAiLCI0NDU5IiwiNDQ2MyIsIjQ0NjYiXX0sImlhdCI6MTU3NzcyNjc0OX0.nPdvtqi-33XmHQIlOu_cU5c_8si9i0cLgxP3Czr6To4`; 
let socket = io.connect(url, {
    'reconnection delay': 0,
    'reopen delay': 0,
    'force new connection': true,
    'transports': ['websocket'],
    'query': `token=${token}`
});

Vue.use(VueSocketIO, socket);
Vue.use(VueAxios, axios)

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
